import React,{useState} from 'react'
import { Link } from 'react-router-dom';
import EventShow from './EventShow';

const Event = () => {
    const [selectedVideo, setSelectedVideo] = useState(false);

  return (
    <div>  
     
      


    {selectedVideo ? ( 
      <section class="th-blog-wrapper space-top space-extra-bottom">
      <div class="container">
      <Link

className=" th-icon"
onClick={() => setSelectedVideo(false)}
>
Back
</Link>
          <div class="row"  style={{alignItems:"center", justifyContent:"center"}}>
              <div class="col-xxl-8 col-lg-7">
                  <div class="th-blog blog-single has-post-thumbnail">
                      <div class="blog-img">
                          <a href="blog-details.html"><img src="assets/img/category/category_1_5.png" alt="Blog Image"/></a>
                      </div>
                      <div class="blog-content">
                          <div class="blog-meta">
                              <a class="author" href="blog.html">9:00 AM - 6:00 PM</a>
                              <a href="blog.html"><i class="fa-solid fa-calendar-days"></i>April 24-25, 2025</a>
                              <a href="blog-details.html"><img src="assets/img/icon/map.svg" alt=""/>HICC, Hyderabad, India</a>
                          </div>
                          <h2 class="blog-title"><a href="blog-details.html">Drone Expo 2025 - Hyderabad</a>
                          </h2>
                          <p class="blog-text">Join us at Drone Expo 2025, Asia's largest gathering of drone enthusiasts, manufacturers, and professionals. This three-day event will showcase the latest innovations in drone technology, featuring industry leaders, live demonstrations, and hands-on workshops.</p>
                      </div>
                  </div>
                
                 
              </div>
            
          </div>
      </div>
  </section> 

     ):(    
  <div>
  <section class="tour-area position-relative bg-top-center overflow-hidden space" id="service-sec" style={{ background: "rgba(243, 240, 216, 1)" }}>
 
 <div class="container">
     <div class="row">
         <div class="col-lg-6 offset-lg-3">
             <div class="title-area text-center">
                 <span class="sub-title">Drone Expo 2025 - Hyderabad</span>
                 <p class="sec-text">Join the largest gathering of drone enthusiasts, manufacturers, and professionals!</p>
             </div>
           
         </div>
     </div>
     
 </div>

</section>
<section class="position-relative overflow-hidden space-bottom" id="destination-sec">
     <div class="container">
         <div class="title-area text-center">
             <span class="sub-title">Services We Offer</span>
             <h2 class="sec-title">Our Amazing services</h2>
         </div>
         <div class="row gy-4 gx-4">
             <div class="col-xl-3 col-lg-4 col-md-6">
                 <div class="destination-item th-ani">
                     <div class="destination-item_img global-img">
                         <img src="assets/img/category/category_1_5.png" alt="image"/>
                     </div>
                     <div style={{marginTop:"2%"}}>
                         <h3 class="box-title"><a href="service-details.html">Drone Expo 2025 - Hyderabad</a></h3>
                         <p class="sec-text"><i className="fa fa-calendar-alt mr-1"></i> April 24 - 26</p>
                         <p class="sec-text"> <i className="fa fa-map-marker-alt mr-1"></i> HICC, Hyderabad, India</p>
                        <div className="header-button">
                        <Link

className="th-btn th-icon"
onClick={() => setSelectedVideo(true)}
>
View Details
</Link>
                                         </div>
                     </div>
                 </div>
             </div>

            

             

            

            

            
         </div>
     </div>
 </section>
  </div>
  
  )    }                       
<footer class="footer-wrapper footer-layout1">
         <div class="widget-area">
             <div class="container">
                 <div class="newsletter-area">
                     <div class="newsletter-top">
                         <div class="row gy-4 align-items-center">
                             <div class="col-lg-5">
                                 <h2 class="newsletter-title text-capitalize mb-0">Subscribe to Drone TV</h2>
                             </div>
                             <div class="col-lg-7">
                                 <form class="newsletter-form">
                                     <input class="form-control " type="email" placeholder="Enter Email" required=""/>
                                     <button type="submit" class="th-btn style3">Subscribe Now <img src="assets/img/icon/plane.svg" style={{width:"50%", height:"50%"}} alt="/"/></button>
                                 </form>
                             </div>
                         </div>
                     </div>
                 </div>
                 <div class="row justify-content-between">
                     <div class="col-md-6 col-xl-3">
                         <div class="widget footer-widget">
                             <div class="th-widget-about">
                                 <div class="about-logo">
                                     <a href="home-travel.html"><img src="assets/img/hero/logo.jpg" alt="Tourm"/></a>
                                 </div>
                               
                             </div>
                         </div>
                     </div>
                     <div class="col-md-6 col-xl-auto">
                         <div class="widget widget_nav_menu footer-widget">
                             <h3 class="widget_title">Quick Links</h3>
                             <div class="menu-all-pages-container">
                                 <ul class="menu">
 
                                 <li>
                         <Link to="/" className="active">Home</Link>
                       </li>
                       <li>
                         <Link to="/video">Videos</Link>
                       </li>
                       <li>
                         <Link to="/event">Events</Link>
                       </li>
                       <li>
                         <Link to="/community">Community</Link>
                       </li>
                                 </ul>
                             </div>
                         </div>
                     </div>
                     <div class="col-md-6 col-xl-auto">
                         <div class="widget footer-widget">
                             <h3 class="widget_title">Address</h3>
                             <div class="th-widget-contact">
                                 <div class="info-box_text">
                                     <div class="icon">
                                         <img src="assets/img/icon/phone.svg" alt="img"/>
                                     </div>
                                     <div class="details">
                                         <p style={{marginTop:"12px"}}><a href="tel:+917520123555" class="info-box_link">+91 7520123555</a></p>
                                     </div>
                                 </div>
                                 <div class="info-box_text">
                                     <div class="icon">
                                         <img src="assets/img/icon/envelope.svg" alt="img"/>
                                     </div>
                                     <div class="details">
                                         <p style={{marginTop:"12px"}}><a href="mailto:info@dronetv.in" class="info-box_link">info@dronetv.in</a></p>
                                     </div>
                                 </div>
                                 <div class="info-box_text">
                                     <div class="icon"><img src="assets/img/icon/location-dot.svg" alt="img"/></div>
                                     <div class="details">
                                         <p style={{marginTop:"12px"}}> HICC, Hyderabad, India</p>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                     <div class="col-md-6 col-xl-auto">
                         <div class="widget footer-widget">
                             <h3 class="widget_title">Social media</h3>
                             <div class="th-social">
                                     <a href="https://www.facebook.com/"><i class="fab fa-facebook-f"></i></a>
                                     <a href="https://www.twitter.com/"><i class="fab fa-twitter"></i></a>
                                     <a href="https://www.linkedin.com/"><i class="fab fa-linkedin-in"></i></a>
                                     <a href="https://www.whatsapp.com/"><i class="fab fa-whatsapp"></i></a>
                                     <a href="https://instagram.com/"><i class="fab fa-instagram"></i></a>
                                 </div>
                         </div>
                     </div>
                 </div>
             </div>
         </div>
         <div class="copyright-wrap" data-bg-src="assets/img/bg/copyright_bg_1.jpg">
             <div class="container">
                 <div class="row justify-content-between align-items-center" style={{textAlign:"center"}}>
                     <div class="col-md-6">
                         <p class="copyright-text">Copyright 2025 <a href="home-travel.html">AJS Innovations</a>. All Rights Reserved.</p>
                     </div>
                    
                 </div>
 
             </div>
         </div>
 
     </footer>
    </div>

  );
};

export default Event;
